import Menu from "./Menu";
import noise from "../../contents/dev/noise.png";
import { Link } from "react-router-dom";

export default function Footer({isVisibleMenu}) {
    return (
        <footer className="relative border-t-2 border-gray-2 bg-gray-1  w-full"
                style={{zIndex: 3, backgroundImage: `url(${noise})`}}>

            <div
                className="w-full px-4 sm:px-10 md:px-20 lg:px-32 2xl:px-40 pt-6 content mx-auto">
                {/* Верхняя часть футера */}
                <div className="flex flex-wrap justify-between items-start gap-y-6">
                    <div className="text-yellow-400 font-sans text-xl font-bold">
                        Start your next project with us!<br/>
                        Join our team; send us your CV!
                    </div>

                    <div className="hidden xl:flex items-center space-x-12">
                        {
                            isVisibleMenu ? <Menu/> :<></>
                        }
                        <div className="-mt-2">
                            <Link to="/">
                                <span className="text-2xl text-white font-bold font-sans">3Dot</span>
                                <span className="text-2xl text-yellow-400 font-bold font-sans">Studio</span>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="flex flex-wrap items-center text-white my-6 gap-x-0 sm:gap-x-10 sm:gap-y-0 gap-y-2">
                    <a target="_blank" rel="noopener noreferrer" href = "mailto: sales@3dotstudio.info">
                        <div className="flex items-center space-x-2">
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M28.5477 3.45117H3.44975C1.72426 3.45117 0.328186 4.86294 0.328186 6.58842L0.3125 25.412C0.3125 27.1374 1.72426 28.5492 3.44975 28.5492H28.5477C30.2733 28.5492 31.685 27.1374 31.685 25.412V6.58842C31.685 4.86294 30.2733 3.45117 28.5477 3.45117ZM27.9203 10.1178L16.8302 17.0512C16.3282 17.3649 15.6694 17.3649 15.1674 17.0512L4.07721 10.1178C3.68504 9.86686 3.44975 9.44333 3.44975 8.98842C3.44975 7.93745 4.59486 7.31 5.48897 7.85901L15.9988 14.4316L26.5086 7.85901C27.4027 7.31 28.5477 7.93745 28.5477 8.98842C28.5477 9.44333 28.3124 9.86686 27.9203 10.1178Z"
                                    fill="white"/>
                            </svg>
                            <div>sales@3dotstudio.info</div>
                        </div>
                    </a>
                </div>
            </div>


            <div className="text-gray-2 border-t-2 border-gray-2 w-full">
                <div className="text-center py-2 text-sm">
                    2025 © - all rights reserved
                </div>
            </div>
        </footer>
    );
}